import { DocumentReference, DocumentSnapshot } from "@atgof-firebase/types";
import { useSnapshot } from "./useSnapshot";
import _ from "lodash";

export function useDocument(
  refOrSnapshot: DocumentReference | DocumentSnapshot | undefined,
) {
  const path =
    refOrSnapshot && "path" in refOrSnapshot ? refOrSnapshot.path : undefined;
  const doc = useSnapshot<DocumentSnapshot | undefined>(
    refOrSnapshot && "onSnapshot" in refOrSnapshot
      ? _.bind(refOrSnapshot.onSnapshot, refOrSnapshot)
      : undefined,
    [path],
  );
  if (refOrSnapshot && !("onSnapshot" in refOrSnapshot)) return refOrSnapshot;
  return doc;
}
